import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

const line = {
  hidden: { y: "112%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.15, delay: i * 0.12, ease: EASE } }),
};

export const MaskLines = ({ lines, className = "", lineClass = "", play, delay = 0, as = "div", ...rest }) => {
  const M = motion[as];
  const trigger = play === undefined
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: play ? "show" : "hidden" };
  return (
    <M className={className} initial="hidden" {...trigger} transition={{ delayChildren: delay }} {...rest}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span custom={i + delay * 8} variants={line} className={`block ${lineClass}`}>
            {l}
          </motion.span>
        </span>
      ))}
    </M>
  );
};
